import { combineReducers } from "redux";
import { createMigrate, persistReducer } from 'redux-persist'
// import createTransform from "redux-persist/lib/createTransform";
import localStorage from "redux-persist/lib/storage";
import _ from 'lodash';

import AuthReducer from "./AuthReducer";
import ItemsReducer from "./ItemsReducer";
import SettingsReducer from "./SettingsReducer";
import FiltersReducer from "./FiltersReducer";
import ActivityReducer from "./ActivityReducer";
import WishListReducer from "./WishListReducer";
import SubscriptionsReducer from "./SubscriptionReducer";
import { APIManager } from "../utils/api";
import APIUrls from "../constants/ApiUrls";

// //////////////////////////////////////////////////////////////////
// Transforms (filters)

// Custom transform to remove 'item' from the persisted state
// const removeItemTransform = createTransform(
//   (inboundState, key) => {
//     if (["item", "items", "filtered"].includes(key)) return undefined; // Do not persist 'item'
//     return inboundState; // Pass through all other state
//   },
//   (outboundState, key) => outboundState // No change on rehydration
// );

// //////////////////////////////////////////////////////////////////
// Migrations 
const migrations = {
  // Migration 0: migrate tenant to fetch new tenant with algolia search key
  0: async (state) => {
    let tenant = state.tenant;
    if (state.cognitoUser.attributes.email) {
      const data = await APIManager.Instance.call("GET", APIUrls.getTenant(state.cognitoUser.attributes.email));
      tenant = data.tenant;
    }
    return {
      ...state,
      tenant
    }
  },
  // Migration 1: store email in localStorage, rc/2024-q2-v2-upgrade-01
  // 1: async (state) => {
  //   console.log({state, info: "migrating to version 1"});
  //   if (_.get(state, "auth.cognitoUser.attributes.email", false)) {
  //     const email = state.auth.cognitoUser.attributes.email;
  //     localStorage.setItem("email", email);
  //   }
  //   return state; // Return the state as is, since no actual state changes are needed
  // },
}

// //////////////////////////////////////////////////////////////////
// Persistence

const authPersistConfig = {
  key: 'auth',
  version: 1,
  storage: localStorage,
  blacklist: ['Auth', 'Analytics'],
  migrate: createMigrate(migrations, { debug: false })
}

// const RootReducer = combineReducers({  
const AppReducer = combineReducers({
  auth: persistReducer(authPersistConfig, AuthReducer),
  item: ItemsReducer,
  settings: SettingsReducer,
  filters: FiltersReducer,
  activity: ActivityReducer,
  wishlist: WishListReducer,
  subscriptions:SubscriptionsReducer
});

const RootReducer = (state, action) => {
  // console.log({action, info: "RootReducer"});
  // let newState = {};
  // let newAction = null;
  // if (action.type === 'persist/REHYDRATE') {
  //   console.log('Rehydrated State: ', action.payload);
  // }
  if (action.type === 'USER_LOGOUT') {
    // console.log('action for root: ', action.type);
    localStorage.removeItem('email'); // Clear the stored email on logout
    // remove persist values
    localStorage.removeItem("persist:root");
    localStorage.removeItem("persist:auth");
    state = undefined;
      
    //   newState = {};
    //   newAction = null;
    // } else {
    //   newState = state;
    //   newAction = action;
  }
  // delegate to combined reducers
  return AppReducer(state, action);
}

export default RootReducer;
